import { EnumCategories } from "models/Ticket";

export const categoryToDisableArray = [
  EnumCategories.DEVOLUCAO,
  EnumCategories.RECLAMACAO_TECNICA,
  EnumCategories.OCORRENCIA_TRANSPORTADORA
];